import { render, staticRenderFns } from "./MoreAffordableIcon.vue?vue&type=template&id=82035ec0&"
import script from "./MoreAffordableIcon.vue?vue&type=script&lang=js&"
export * from "./MoreAffordableIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports